import React from 'react';
import { Chart } from 'primereact/chart';
import { IWeeklyStatus } from './ShareIssue';

interface ShareIssueWeeklyChartProps {
  weeklyStatusData: IWeeklyStatus;
}

export const ShareIssueWeeklyChart: React.FC<ShareIssueWeeklyChartProps> = ({
  weeklyStatusData,
}) => {
  // Doughnut Chart options
  const chartOptions = {
    plugins: {
      legend: {
        position: 'bottom',
      },
    },
  };

  return (
    <div className="w-1/2 col-span-2 card">
      <h5>Weekly Status Overview</h5>
      <Chart type="bar" data={weeklyStatusData} options={chartOptions} />
    </div>
  );
};
